import { getDrHoffmannPublicUrl } from "./siteUrls";
import { isDrHoffmannHandoffHost } from "./handoffHosts";

/** Only allow redirects back to this Dr. Hoffmann frontend. */
export const isAllowedHandoffUrl = (urlString) => {
  try {
    const url = new URL(urlString);
    if (!isDrHoffmannHandoffHost(url.hostname)) return false;
    if (url.hostname === "localhost") {
      const port = url.port || (url.protocol === "https:" ? "443" : "80");
      return port === "4000" || port === "3000" || port === "80";
    }
    return url.pathname.startsWith("/auth/tawan-weiterleitung");
  } catch {
    return false;
  }
};

/** JWT in query strings may decode '+' as space — repair before verify. */
export const parseHandoffAuthToken = (search = "", hash = "") => {
  const hashParams = new URLSearchParams(
    String(hash || "").replace(/^#/, "")
  );
  const queryParams = new URLSearchParams(search);
  const raw = hashParams.get("auth_token") || queryParams.get("auth_token");
  if (!raw) return null;
  return raw.replace(/ /g, "+");
};

export const buildTawanHandoffReturnUrl = (nextPath = "/buchen") => {
  const origin = getDrHoffmannPublicUrl();
  const next = String(nextPath || "/buchen").startsWith("/")
    ? nextPath
    : `/${nextPath}`;
  return `${origin}/auth/tawan-weiterleitung?next=${encodeURIComponent(next)}`;
};
